function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) : typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) : (global = global || self, factory(global.findifyReactBundle = {}, global.react));
})(this, function (exports, react) {
  'use strict';

  var eventBindings = {
    autocomplete: 'change:suggestions',
    recommendation: 'change:items',
    search: 'change:items',
    'smart-collection': 'change:items'
  };

  var randomKey = function randomKey() {
    return Math.random().toString(36).substring(7);
  };

  var waitForFindify = function waitForFindify() {
    return new Promise(function (resolve) {
      return (window.findifyCallbacks = window.findifyCallbacks || []).push(function (findify) {
        return resolve(findify);
      });
    });
  };

  var getWidgetConfig = function getWidgetConfig(type, node, config, customs) {
    if (type !== 'recommendation') {
      return customs;
    }

    var cfg = config.getIn(['features', 'recommendations', customs.slot || node.getAttribute('id')]);

    if (!cfg) {
      cfg = config.getIn(['features', 'recommendations', "#".concat(customs.slot || node.getAttribute('id'))]);
    }

    return cfg.mergeDeep(customs);
  };

  var cleanCollectionSlot = function cleanCollectionSlot(slot) {
    return slot.replace(/^\/|\/$/g, "").toLowerCase();
  };

  var index = function index(_ref) {
    var type = _ref.type,
        _ref$config = _ref.config,
        config = _ref$config === void 0 ? {} : _ref$config,
        _ref$options = _ref.options,
        options = _ref$options === void 0 ? {} : _ref$options,
        history = _ref.history,
        _ref$widgetKey = _ref.widgetKey,
        widgetKey = _ref$widgetKey === void 0 ? randomKey() : _ref$widgetKey;
    var container = react.useRef(null);

    var _react$useState = react.useState(false),
        _react$useState2 = _slicedToArray(_react$useState, 2),
        ready = _react$useState2[0],
        setReady = _react$useState2[1];

    var _react$useState3 = react.useState(false),
        _react$useState4 = _slicedToArray(_react$useState3, 2),
        hasError = _react$useState4[0],
        setError = _react$useState4[1];

    react.useEffect(function () {
      if (!container.current) return;
      var findify = void 0;
      var shouldRender = true;

      var init = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var collectionSlot, widgetConfig, widget, meta, defaultRequestParams, defaults, callback;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return waitForFindify();

                case 2:
                  findify = _context.sent;

                  if (type === 'smart-collection') {
                    collectionSlot = config.slot && config.slot !== '' ? cleanCollectionSlot(config.slot) : findify.utils.collectionPath();

                    if (!findify.utils.isCollection(findify.config.get('collections'), collectionSlot)) {
                      shouldRender = false;
                      setError(true);
                    }
                  }

                  if (shouldRender) {
                    _context.next = 6;
                    break;
                  }

                  return _context.abrupt("return");

                case 6:
                  if (history) {
                    findify.utils.setHistory ? findify.utils.setHistory(history) : findify.utils.history = history;
                  }

                  widgetConfig = getWidgetConfig(type, container.current, findify.config, _objectSpread({
                    widgetKey: widgetKey,
                    disableAutoRequest: true
                  }, config));
                  findify.widgets.attach(container.current, type === 'smart-collection' ? 'search' : type, widgetConfig);
                  widget = findify.widgets.get(widgetKey);
                  meta = widget.config.get('meta') && widget.config.get('meta').toJS() || {};
                  defaultRequestParams = widget.config.get('defaultRequestParams') && widget.config.get('defaultRequestParams').toJS() || {};
                  defaults = _objectSpread(_objectSpread(_objectSpread({}, meta), defaultRequestParams), options);

                  if (type === 'recommendation') {
                    defaults.slot = config.slot;
                    defaults.type = config.type || widgetConfig.get('type');
                  }

                  if (collectionSlot) {
                    defaults.slot = collectionSlot;
                  }

                  callback = function callback(items) {
                    return window.requestAnimationFrame(function () {
                      widget.agent.off(callback);
                      if (!items.size) setError(true);
                      setReady(true);
                    });
                  };

                  widget.agent.defaults(defaults).on('error', function () {
                    return setError(true);
                  }).on(eventBindings[type], callback);

                  if (['search', 'smart-collection'].includes(type)) {
                    widget.agent.applyState(findify.utils.getQuery());
                  }

                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function init() {
          return _ref2.apply(this, arguments);
        };
      }();

      init();
      return function () {
        console.log('detach', widgetKey);

        if (findify && findify.widgets.get(widgetKey)) {
          findify.widgets.detach(widgetKey);
        } else {
          shouldRender = false;
        }
      };
    }, [container]);
    return [container, ready, hasError];
  };

  exports.default = index;
  exports.waitForFindify = waitForFindify;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});